// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.ProductCard__favorite[data-v-05333b12]{\n  display:flex;\n  align-items:center;\n  transition:transform .2s ease-in-out;\n}\n[dir] .ProductCard__favorite[data-v-05333b12]:hover{\n    transform:scale(1.2)\n}\n.ProductCard__favorite svg.is-active path[data-v-05333b12]{\n    fill:currentColor;\n    --tw-text-opacity:1;\n    color:rgba(190, 30, 70, var(--tw-text-opacity))\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
